<div class="d-flex s_between align-items-center">
  <div class="">
    <p class="mb-1 txt-regular fs-12">
      You have
      <strong>{{ sendProfileComData?.hasnotindicated_count }} days</strong>
      where you haven't<br />indicated your availability.
    </p>
    <div class="mt-15">
      <a appFocus class="user-title c-p clr-cc-vilot" (click)="goToCalendar()"
        >Update availability
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-arrow-right"
          viewBox="0 0 16 17"
          stroke="currentColor"
          stroke-width="1"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
          />
        </svg>
      </a>
    </div>
  </div>
  <div class="text-end">
    <div class="col-4 text-end">
      <div class="progress-circle-container">
        <svg class="progress-ring" width="80" height="80">
          <circle class="progress-ring__background" cx="40" cy="40" r="35" />
          <circle
            class="progress-ring__circle"
            cx="40"
            cy="40"
            r="35"
            [attr.stroke]="
              sendProfileComData?.hasnotindicated_percentage == 100
                ? '#18C864'
                : '#18C864'
            "
            stroke-width="7"
            fill="none"
            [attr.stroke-dasharray]="
              getSmallProfileDashArray(
                sendProfileComData?.hasnotindicated_percentage
              )
            "
            [attr.stroke-dashoffset]="
              getSmallProfileDashOffset(
                sendProfileComData?.hasnotindicated_percentage
              )
            "
            transform="rotate(-90 40 40)"
          />
        </svg>
        <div class="progress-label">
          <div class="fw-bold">
            {{ 100 - sendProfileComData?.hasnotindicated_percentage }}%
          </div>
          <small class="fs-10">Availability<br />Indicated</small>
        </div>
      </div>
    </div>
  </div>
</div>
